import React from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BsPlusCircleFill, BsXCircleFill } from "react-icons/bs";
import { GrEdit } from "react-icons/gr";
import {
  RiArrowLeftLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiBuilding2Line,
  RiCheckboxCircleLine,
  RiCarLine,
  RiHashtag,
  RiSettings3Line,
} from "react-icons/ri";

const buildPosicionesPreview = (cantidad) => {
  const total = Math.max(Number(cantidad) || 1, 1);
  const posiciones = [];
  if (total >= 1) posiciones.push("Piloto");
  if (total >= 2) posiciones.push("Copiloto");
  for (let i = 3; i <= total; i += 1) {
    posiciones.push(`T${i - 2}`);
  }
  return posiciones;
};

const buildPosicionesFromType = (tipoVehiculo, cantidad) => {
  const normalized = String(tipoVehiculo || "").trim().toLowerCase();
  if (normalized === "cabina_tres_literas") return ["Conductor", "Copiloto", "L1", "L2", "L3"];
  if (normalized === "cabina_centro") return ["Conductor", "Piloto", "Centro"];
  if (normalized === "cabina_litera") return ["Conductor", "Copiloto", "Litera"];
  return buildPosicionesPreview(cantidad);
};

export function VehiculosTabla({
  handleShowModal,
  handleShowAsignacion,
  datos,
  eliminar,
  datosaeditar,
  page,
  totalPages,
  totalElements,
  loading,
  onPrev,
  onNext,
}) {
  const navigation = useNavigate();

  return (
    <>
      <Button style={{ width: "100%", marginBottom: "12px" }} onClick={() => navigation("/panel-administrador")}>
        <RiArrowLeftLine style={{ marginRight: 8 }} /> Atrás
      </Button>

      <div style={{ width: "100%", marginBottom: "12px" }}>
        <Button onClick={() => handleShowModal("Nuevo")}>
          <BsPlusCircleFill /> Agregar
        </Button>
      </div>

      <div style={{ width: "100%" }}>
        <div className="table-responsive">
          <Table striped bordered hover variant="dark">
            <thead>
              <tr>
                <th><RiHashtag style={{ marginRight: 6 }} />Código</th>
                <th><RiBuilding2Line style={{ marginRight: 6 }} />Empresa</th>
                <th><RiCarLine style={{ marginRight: 6 }} />Placa</th>
                <th>Nombre</th>
                <th>Cinturones</th>
                <th><RiCheckboxCircleLine style={{ marginRight: 6 }} />Estado</th>
                <th><RiSettings3Line style={{ marginRight: 6 }} />Acciones</th>
              </tr>
            </thead>
            <tbody>
              {(!datos || datos.length === 0) && (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center", opacity: 0.8 }}>
                    {loading ? "Cargando..." : "No hay registros"}
                  </td>
                </tr>
              )}

              {datos &&
                datos.map((vehiculo) => (
                  <tr key={vehiculo.id}>
                    <td>{vehiculo.id}</td>
                    <td>{vehiculo.empresasModel?.nombre ?? "-"}</td>
                    <td>{vehiculo.placa}</td>
                    <td>{vehiculo.nombre}</td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <strong>{vehiculo.cantidadCinturones ?? 1}</strong>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                          {buildPosicionesFromType(vehiculo.tipoVehiculo, vehiculo.cantidadCinturones).map((posicion) => (
                            <span
                              key={`${vehiculo.id}-${posicion}`}
                              style={{
                                padding: "3px 8px",
                                borderRadius: 999,
                                fontSize: 11,
                                background: "rgba(47, 134, 255, 0.14)",
                                border: "1px solid rgba(47, 134, 255, 0.22)",
                              }}
                            >
                              {posicion}
                            </span>
                          ))}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span style={{ padding: "4px 8px", borderRadius: 999, background: vehiculo.estado ? "#198754" : "#6c757d" }}>
                        {vehiculo.estado ? "Activo" : "Inactivo"}
                      </span>
                    </td>
                    <td>
                      <Button variant="warning" style={{ marginInline: "10px" }} onClick={() => datosaeditar(vehiculo)}>
                        <GrEdit /> Editar
                      </Button>
                      <Button variant="info" style={{ marginInline: "10px" }} onClick={() => handleShowAsignacion(vehiculo)}>
                        <RiSettings3Line /> Cinturones
                      </Button>
                      <Button variant="danger" style={{ marginInline: "10px" }} onClick={() => eliminar(vehiculo.id)}>
                        <BsXCircleFill /> Eliminar
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          marginTop: "12px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        <Button variant="outline-light" disabled={loading || page <= 0} onClick={onPrev}>
          <RiArrowLeftSLine /> Anterior
        </Button>

        <span style={{ opacity: 0.85 }}>
          {loading ? "Cargando..." : `Página ${page + 1} / ${Math.max(totalPages, 1)} • ${totalElements} registros`}
        </span>

        <Button variant="outline-light" disabled={loading || page + 1 >= totalPages} onClick={onNext}>
          Siguiente <RiArrowRightSLine />
        </Button>
      </div>
    </>
  );
}
